import React, { Component } from "react";
import Intro from "./Intro";
import Request from "./Request";
import Results from "./Results";

class SingleProject extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Intro projectId={this.props.match.params.id} />
        <Request projectId={this.props.match.params.id} />
        <Results projectId={this.props.match.params.id} />
      </div>
    );
  }
}

export default SingleProject;



// WEBPACK FOOTER //
// ./src/components/SingleProject/SingleProject.js